import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"
import { Slot } from "radix-ui"

import { cn } from "@/lib/utils"

// Pastille du canevas v0.5.0 (chip) : pilule, fond doux du ton, texte du ton (≥ 5,9:1), 12 px medium.
const badgeVariants = cva(
  "inline-flex w-fit shrink-0 items-center justify-center gap-[5px] overflow-hidden rounded-full border border-transparent px-[9px] py-[3px] text-xs font-medium whitespace-nowrap transition-[color,box-shadow] aria-invalid:border-destructive [&>svg]:pointer-events-none [&>svg]:size-3",
  {
    variants: {
      variant: {
        // acc : sarcelle sur accSoft.
        default: "bg-brand-subtle text-brand-text [a&]:hover:bg-brand-subtle/80",
        // mute : encre 2 sur le fond neutre.
        secondary:
          "bg-surface-sunken text-muted-foreground [a&]:hover:bg-surface-sunken/80",
        // red : brique sur redSoft.
        destructive:
          "bg-error-soft text-error-text [a&]:hover:bg-error-soft/80",
        success: "bg-success-soft text-success-text",
        warning: "bg-warning-soft text-warning-text",
        info: "bg-info-soft text-info-text",
        outline:
          "border-border text-foreground [a&]:hover:bg-accent [a&]:hover:text-accent-foreground",
        ghost: "[a&]:hover:bg-accent [a&]:hover:text-accent-foreground",
        link: "text-brand-text underline-offset-4 [a&]:hover:underline",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

function Badge({
  className,
  variant = "default",
  asChild = false,
  ...props
}: React.ComponentProps<"span"> &
  VariantProps<typeof badgeVariants> & { asChild?: boolean }) {
  const Comp = asChild ? Slot.Root : "span"

  return (
    <Comp
      data-slot="badge"
      data-variant={variant}
      className={cn(badgeVariants({ variant }), className)}
      {...props}
    />
  )
}

export { Badge, badgeVariants }
